export enum DateAmountType {
  days = 0,
  months = 1,
}
